import AbstractApisClient from "./AbstractApisClient";
import * as RouterApis from "./routers"; // That client has to be used on main project

class ApisClient extends AbstractApisClient {
  constructor(params) {
    super(params);
    this.auth = new RouterApis.AuthApis(this);
    this.ums = new RouterApis.UmsApis(this);
    this.reference = new RouterApis.ReferenceApis(this);
  }

}

export default ApisClient;